import { ColetaRequestParams } from './../../../../../../../dados-hidrologicos/interfaces/coleta-reservatorios';
import { Component, Input, OnInit } from '@angular/core';
import { ReservatorioColetas } from '@modulos/recursos-hidricos/submodulos/reservatorio/interfaces/form-reservatorio';
import { isNotNuloOuUndefined, numberToBrNumber } from '@utils';

@Component({
	selector: 'seira-popup-mapa-qualidade-agua',
	templateUrl: './popup-mapa-qualidade-agua.component.html',
	styleUrls: ['./popup-mapa-qualidade-agua.component.scss'],
})
export class PopupMapaQualidadeAguaComponent implements OnInit {
	@Input() markerData!: ColetaRequestParams;
	@Input() reservatorioColetas!: ReservatorioColetas[];
	nomeReservatorio: string | null;
	tipoReservatorio: string | null;

	protected readonly isNotNuloOuUndefined = isNotNuloOuUndefined;

	ngOnInit(): void {
		this.reservatorioColetas.find(el => {
			if (el.id === this.markerData.reservatorioId) {
				this.nomeReservatorio = el.nomeReservatorio;
				this.tipoReservatorio = el.tipoReservatorio;
			}
		});
	}

	protected readonly numberToBrNumber = numberToBrNumber;
}
